import Abort from './Abort'
import abortContainer from './abortContainer'

export default abortContainer(Abort)
